import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Global";

const useTheme = (initialTheme) => {
  let themeOptions = [
    "light",
    "dark",
    "black",
    "compact",
    "detailed",
    "detailed",
    "closed",
  ];

  const dispatch = useDispatch();

  const storedTheme = localStorage.getItem("theme");

  const [theme, setTheme] = useState(storedTheme || initialTheme);

  const handleThemeChange = (selectedTheme) => {
    setTheme(selectedTheme);

    localStorage.setItem("theme", selectedTheme);
  };

  useEffect(() => {
    dispatch(
      updateConfig((state) => {
        state.currentTheme = storedTheme;
      })
    );
    // eslint-disable-next-line
  }, [storedTheme]);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.body.classList.remove(...themeOptions);
    document.body.classList.add(theme);
    document.body.setAttribute("data-theme", theme);

    // eslint-disable-next-line
  }, [theme]);

  return { theme, handleThemeChange, setTheme };
};

export default useTheme;
